const doc = [({"da":({"js":({"admin":({"contacts":({"edit":({"billing_contact":({"billing_information":"Betalingsoplysning"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;